var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sa-no-data"},[_c('img',{staticClass:"sa-img-responsive",attrs:{"src":require("../../assets/img/no-data-found.svg"),"alt":"No Data Found"}}),_c('h2',[_c('strong',[_vm._v("No Data Found")])])])
}]

export { render, staticRenderFns }